export function skippedCompletionIds(completions, billingContext) {
  if (!Array.isArray(billingContext?.included_completion_ids)) return new Set();
  const included = new Set(billingContext.included_completion_ids);
  return new Set(completions.filter(completion => !included.has(completion.id)).map(completion => completion.id));
}

export default function InvocationBilling({ completions, billingContext }) {
  if (typeof billingContext?.credits_billed !== "number") return null;
  const skippedCount = skippedCompletionIds(completions, billingContext).size;
  return (
    <div className="flex items-center gap-3 bg-indigo-50 border border-indigo-100 rounded-lg px-4 py-2 min-w-[250px]">
      <div className="flex flex-col text-xs">
        <span className="font-semibold text-gray-700">Credits Charged</span>
        <span className="text-gray-500">
          {skippedCount > 0
            ? skippedCount === completions.length ? "All completions skipped billing" : "Some completions skipped billing"
            : "Actual ledger deduction"}
        </span>
      </div>
      <div className="text-2xl font-bold text-indigo-700 tabular-nums">{billingContext.credits_billed.toLocaleString()}</div>
    </div>
  );
}
